module.exports = require("live/services/shortcut-manager");